/*
 * @Description: 核心分析视图
 * @Author: yuanmc
 * @Date: 2025-10-29 15:30:00
 * @LastEditTime: 2025-10-29 15:30:00
 * @LastEditors: yuanmc
 */

import moment from 'moment';
import { getTenantCodeByBusinessId, getCurrentBusinessId } from '@/config/waybill-data-whitelist';

const storeModuleName = 'waybillDataAnalysisModule';

// 初始化默认日期（前一天到当天）
const defaultStartDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
const defaultEndDate = moment().format('YYYY-MM-DD');

const state = {
  // 筛选项
  parameters: [
    {
      style: 'date-picker',
      param: 'arriveTimeRange',
      params: ['startDate', 'endDate'], // 导出时使用的参数名
      value: [defaultStartDate, defaultEndDate], // 初始化默认日期，用于表单回显
      valueType: 'array',
      label: '统计日期',
      width: '300px', // 日期范围选择器宽度，确保日期能完整显示
      type: 'daterange',
      placeholder: '开始日期-结束日期',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      size: 'small',
    },
  ],
  // 页码 + 参数
  postParams: {
    startDate: defaultStartDate, // 默认设置为前一天
    endDate: defaultEndDate, // 默认设置为当天
  },
};

const mutations = {
  updateValueFromIndex(state, { index, value }) {
    state.parameters[index].value = value;
  },
  updateParams(state, params) {
    state.postParams = { ...state.postParams, ...params };
  },
  resetParams(state) {
    const startDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');
    state.parameters.forEach(item => {
      if (item.valueType === 'array') {
        if (item.param === 'arriveTimeRange') {
          // 统计日期重置为前一天到当天
          item.value = [startDate, endDate];
        } else {
          item.value = [];
        }
      } else {
        item.value = '';
      }
    });
    state.postParams.startDate = startDate; // 重置为前一天
    state.postParams.endDate = endDate; // 重置为当天
  },
};

const actions = {
  getSearchParams({ state }) {
    // 根据当前企业ID获取对应的租户Code
    const currentBusinessId = getCurrentBusinessId();
    const tenantCode = getTenantCodeByBusinessId(currentBusinessId);

    const params = {
      tenantCode,
    };

    // 处理筛选参数
    state.parameters.forEach(item => {
      // 处理日期范围选择器
      if (
        item.style === 'date-picker' &&
        item.param === 'arriveTimeRange' &&
        item.value &&
        item.value.length === 2
      ) {
        params.startDate = item.value[0];
        params.endDate = item.value[1];
      }
    });

    // 如果没有选择日期，默认使用前一天（作为兜底保护）
    if (!params.startDate || !params.endDate) {
      params.startDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
      params.endDate = moment().format('YYYY-MM-DD');
    }

    return params;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
